import { TagVariant } from "@tvg/design-system";
import { ButtonVariant } from "@tvg/design-system/src/components/button/types";

export enum PAGE {
  ENROLL = 1,
  LEARN_MORE = 2,
  WELCOME = 3
}

export interface FeaturesModalConfig {
  ctaText: string;
  tagText: string;
  ctaVariant: ButtonVariant;
  tagVariant: TagVariant;
}
